import { render, staticRenderFns } from "./TagCountReadingNew.vue?vue&type=template&id=19514f5e&scoped=true"
import script from "./TagCountReadingNew.vue?vue&type=script&lang=js"
export * from "./TagCountReadingNew.vue?vue&type=script&lang=js"
import style0 from "./TagCountReadingNew.vue?vue&type=style&index=0&id=19514f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19514f5e",
  null
  
)

export default component.exports